export default __webpack_public_path__ + "72505e6a122c6acd5471dbc0cb28e12e.woff2";